import React from 'react';
import { Nav } from 'rsuite';
import { PeriodType } from '@/types/primaryLedgerSnapshots';

interface PeriodTypeSelectorProps {
  value: PeriodType;
  onChange: (type: PeriodType) => void;
}

const PeriodTypeSelector: React.FC<PeriodTypeSelectorProps> = ({
  value,
  onChange
}) => {
  return (
    <Nav
      appearance="tabs"
      activeKey={value}
      onSelect={(eventKey) => onChange(eventKey as PeriodType)}
      className="mb-4"
    >
      <Nav.Item eventKey="daily">Daily</Nav.Item>
      <Nav.Item eventKey="weekly">Weekly</Nav.Item>
      <Nav.Item eventKey="monthly">Monthly</Nav.Item>
    </Nav>
  );
};

export default PeriodTypeSelector;